import api from '../config/api';

export const settingsService = {
  getAdminSettings: async () => {
    const response = await api.get('/settings/admin');
    return response.data;
  },

  updateAdminEmail: async (email) => {
    const response = await api.put('/settings/admin/email', { email });
    return response.data;
  },

  updateAdminPassword: async (currentPassword, newPassword) => {
    const response = await api.put('/settings/admin/password', {
      currentPassword,
      newPassword
    });
    return response.data;
  }
};

